/** Business phone — keep identical everywhere for Google Business Profile NAP consistency. */
export const PHONE_NUMBER = "208-639-0241";
export const PHONE_TEL = "tel:+12086390241";
